const CONSTANTS = {
  WIDTH: 1050,
  HEIGHT: 590,
  HTML: {
    TEXTAREA: (width, height, placeholder) => `
    <html>
    <div style="width: ${width}px;background: #9DD4B7;border-radius: 25px;padding: 10px;">
      <textarea id="textarea" type="text" style="width: 100%;height: ${parseInt(
        height * 0.5
      )}px;border: 2px dashed black;border-radius: 25px;outline: none;padding: 15px;background: #9DD4B7;color: black;" placeholder="${placeholder}"></textarea>
    </div>
    <div style="width: ${width}px;display: flex;flex-direction: row;transform: translate(0, -32px)">
        <div style="flex-basis: 50%;display: flex;flex-direction: row;justify-content: flex-start;align-items:center;">
          <img src="https://i.ibb.co/SVcY2Rg/back.png" id="back" hidden/>
          <img src="https://i.ibb.co/BNYMgst/forward.png" id="next" hidden/>
        </div>
        <div style="flex-basis: 50%;display: flex;flex-direction: row;justify-content: flex-end;align-items:center;">
            <img src="https://i.ibb.co/2ZDHD93/done.png" id="done"/>
            <img src="https://i.ibb.co/V2L0pF7/add-more.png" id="add_more"/>
        </div>
    </div>
  </html>
    `,
    RECOMMENDATIONS: (data, width) => `
      <html>
        <div style="width: ${
          width * 0.3
        }%;display: flex;flex-direction: column;justify-content: center; align-items: center;">
          ${data.map(
            item => `
            <div style="width: 100%;background: white;border-radius: 16px;display: flex;justify-content: center;">
              <div style="width: 100%;margin: 10px;display: flex;flex-direction: column;justify-content: center;align-items: flex-start;border: 2px dashed black;padding: 10px">
                <div style="width: 100%;text-align: left;font-size: 20px;font-weight: bold;">${item.title}</div>
                <div style="align-self: flex-end;background: #D1D1FF;border-radius: 25px;padding: 8px">${item.kind}</div>
              </div>
            </div>
          `
          )}
        </div>
      </html>
    `,
    RECOMMENDATION: (entry, width, font) => `
    <html>
      <div style="width: ${
        width * 0.3
      }px;display: flex;flex-direction: column;justify-content: center; align-items: center;">
          <div style="width: 100%;background: white;border-radius: 16px;display: flex;justify-content: center;">
            <div style="width: 100%;margin: 10px;display: flex;flex-direction: column;justify-content: center;align-items: flex-start;border: 2px dashed black;padding: 10px; row-gap: 16px;">
              <div style="width: 100%;text-align: left;font-size: ${font}px;font-weight: bold;">${
      entry.title
    }</div>
              <div style="align-self: flex-end;background: #D1D1FF;border-radius: 25px;padding: 8px;font-size: ${font}px">${
      entry.kind
    }</div>
            </div>
          </div>
      </div>
    </html>`
  }
};

export default CONSTANTS;
